import { useState, useEffect } from 'react'
import api from '../../api/axiosInstance.js'
import Swal from 'sweetalert2'
import MenuButton from '../../components/menuButton/index.js'
import {
  Typography,
  IconButton,
  Box,
  Paper,
  Button,
  Card,
  CardContent,
  Grid,
  Tooltip,
  Divider,
  TextField,
  InputAdornment,
  useTheme,
  Checkbox,
  useMediaQuery,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  FormControlLabel,
  Chip,
  alpha,
} from '@mui/material'
import {
  Add,
  PlayArrow,
  Pause,
  Delete,
  Search,
  Visibility,
  FilterList,
  RestartAlt,
  CheckCircle,
  Error,
  Warning,
  Circle,
  Settings,
  Refresh,
  TrendingUp,
  TrendingDown,
  Dehaze,
  ContentCopy,
} from '@mui/icons-material'
import { DataGrid } from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'
import MonitorStatus from '../../components/Animate/monitorStatus.js'
import { useSelector } from 'react-redux'
import { selectUser } from '../../redux/features/auth/authSelectors'
import { motion } from 'framer-motion'

// Filter Menu Component
function FilterMenu({ filtreOptions, setFiltereOptions }) {
  const theme = useTheme()
  const [filters, setFilters] = useState({
    up: false,
    down: false,
    uncertain: false,
    maintanance: false,
    paused: false,
  })
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  const handleFilterChange = (filterName) => {
    const newFilters = { ...filters, [filterName]: !filters[filterName] }
    setFilters(newFilters)

    const activeFilters = Object.keys(newFilters).filter((key) => newFilters[key])
    setFiltereOptions(activeFilters)
  }

  const handleReset = () => {
    setFilters({
      up: false,
      down: false,
      uncertain: false,
      maintanance: false,
      paused: false,
    })
    setFiltereOptions([])
  }

  const filterOptions = [
    { key: 'up', label: 'Active', color: '#10b981' },
    { key: 'down', label: 'Error', color: '#ef4444' },
    { key: 'uncertain', label: 'Uncertain', color: '#f59e0b' },
    { key: 'maintanance', label: 'Maintenance', color: '#6366f1' },
    { key: 'paused', label: 'Paused', color: '#64748b' },
  ]

  return (
    <>
      <Button
        onClick={handleClick}
        startIcon={<FilterList fontSize="small" />}
        sx={{
          minWidth: 100,
          height: 40,
          border: `1px solid ${alpha('#10b981', 0.3)}`,
          color: '#10b981',
          fontSize: '0.875rem',
          fontWeight: 600,
          borderRadius: 2,
          bgcolor: alpha('#10b981', 0.05),
          transition: 'all 0.2s',
          '&:hover': {
            bgcolor: alpha('#10b981', 0.1),
            borderColor: alpha('#10b981', 0.5),
          },
        }}
      >
        Filters
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            bgcolor: alpha('#0f172a', 0.98),
            backdropFilter: 'blur(20px)',
            border: `1px solid ${alpha('#10b981', 0.2)}`,
            borderRadius: 2,
            minWidth: 200,
            mt: 0.5,
          },
        }}
      >
        {filterOptions.map((option) => (
          <MenuItem
            key={option.key}
            sx={{
              py: 1,
              '&:hover': { bgcolor: alpha('#10b981', 0.1) },
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters[option.key]}
                  onChange={() => handleFilterChange(option.key)}
                  size="small"
                  sx={{
                    color: alpha(option.color, 0.5),
                    '&.Mui-checked': { color: option.color },
                  }}
                />
              }
              label={
                <Typography sx={{ color: '#fff', fontSize: '0.875rem' }}>
                  {option.label}
                </Typography>
              }
            />
          </MenuItem>
        ))}

        <Divider sx={{ my: 1, borderColor: alpha('#10b981', 0.15) }} />

        <MenuItem
          onClick={handleReset}
          sx={{
            justifyContent: 'center',
            py: 1,
            '&:hover': { bgcolor: alpha('#10b981', 0.1) },
          }}
        >
          <RestartAlt sx={{ mr: 1, fontSize: 18, color: '#10b981' }} />
          <Typography sx={{ color: '#10b981', fontSize: '0.875rem', fontWeight: 600 }}>
            Sıfırla
          </Typography>
        </MenuItem>
      </Menu>
    </>
  )
}

// Bulk Actions Menu Component
function BulkActionsMenu({ selectMonitors, setSelectMonitors, setMonitors }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  const handleMultipleDelete = async () => {
    Swal.fire({
      title: 'Silmek istediğinizden emin misiniz?',
      html: `
        <div style="background: ${alpha('#0f172a', 0.95)}; padding: 20px; border-radius: 12px; border: 1px solid ${alpha('#10b981', 0.3)};">
          <p style="color: #ef4444; font-weight: bold; margin-bottom: 10px;">${selectMonitors.length} izleme silinecek!</p>
          <p style="color: rgba(255,255,255,0.8);">Bu işlem geri alınamaz</p>
        </div>
      `,
      icon: 'warning',
      background: alpha('#0f172a', 0.98),
      color: '#fff',
      showCancelButton: true,
      confirmButtonText: 'Evet, Sil',
      cancelButtonText: 'İptal',
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#10b981',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.delete('monitors/multiple-delete', {
            data: { ids: selectMonitors },
          })
          Swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: 'İzlemeler silindi',
            confirmButtonText: 'Tamam',
            background: alpha('#0f172a', 0.98),
            color: '#fff',
            confirmButtonColor: '#10b981',
          })
          setMonitors((prev) => prev.filter((m) => !selectMonitors.includes(m.id)))
          setSelectMonitors([])
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Hata',
            text: error.response?.data?.message || 'Bir hata oluştu',
            confirmButtonText: 'Tamam',
            background: alpha('#0f172a', 0.98),
            color: '#fff',
            confirmButtonColor: '#10b981',
          })
        }
      }
    })
    handleClose()
  }


  const handleMultiPlay = async () => {
    try {
      await api.patch('/monitors/multi-play', { ids: selectMonitors })
      Swal.fire({
        icon: 'success',
        title: 'Başarılı',
        text: 'İzlemeler başlatıldı',
        confirmButtonText: 'Tamam',
        background: alpha('#0f172a', 0.98),
        color: '#fff',
        confirmButtonColor: '#10b981',
      })
      setMonitors((prev) =>
        prev.map((m) =>
          selectMonitors.includes(m.id) ? { ...m, isActiveByOwner: true, status: 'uncertain' } : m
        )
      )
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hata',
        text: 'İşlem başarısız',
        confirmButtonText: 'Tamam',
        background: alpha('#0f172a', 0.98),
        color: '#fff',
        confirmButtonColor: '#10b981',
      })
    }
    handleClose()
  }

  

  const handleMultiPause = async () => {
    try {
      await api.patch('/monitors/multi-pause', { ids: selectMonitors })
      Swal.fire({
        icon: 'success',
        title: 'Başarılı',
        text: 'İzlemeler durduruldu',
        confirmButtonText: 'Tamam',
        background: alpha('#0f172a', 0.98),
        color: '#fff',
        confirmButtonColor: '#10b981',
      })
      setMonitors((prev) =>
        prev.map((m) =>
          selectMonitors.includes(m.id) ? { ...m, isActiveByOwner: false, status: 'uncertain' } : m
        )
      )
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hata',
        text: 'İşlem başarısız',
        confirmButtonText: 'Tamam',
        background: alpha('#0f172a', 0.98),
        color: '#fff',
        confirmButtonColor: '#10b981',
      })
    }
    handleClose()
  }

  return (
    <>
      <Button
        onClick={handleClick}
        startIcon={<Dehaze fontSize="small" />}
        disabled={selectMonitors.length === 0}
        sx={{
          minWidth: 120,
          height: 40,
          border: `1px solid ${selectMonitors.length > 0 ? alpha('#10b981', 0.3) : alpha('#fff', 0.1)}`,
          color: selectMonitors.length > 0 ? '#10b981' : alpha('#fff', 0.3),
          fontSize: '0.875rem',
          fontWeight: 600,
          borderRadius: 2,
          bgcolor: selectMonitors.length > 0 ? alpha('#10b981', 0.05) : 'transparent',
          transition: 'all 0.2s',
          '&:hover': selectMonitors.length > 0 && {
            bgcolor: alpha('#10b981', 0.1),
            borderColor: alpha('#10b981', 0.5),
          },
        }}
      >
        Multiple Processing
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            bgcolor: alpha('#0f172a', 0.98),
            backdropFilter: 'blur(20px)',
            border: `1px solid ${alpha('#10b981', 0.2)}`,
            borderRadius: 2,
            minWidth: 180,
            mt: 0.5,
          },
        }}
      >
        <MenuItem
          onClick={handleMultiPlay}
          sx={{
            py: 1.25,
            '&:hover': { bgcolor: alpha('#10b981', 0.15) },
          }}
        >
          <ListItemIcon>
            <PlayArrow fontSize="small" sx={{ color: '#10b981' }} />
          </ListItemIcon>
          <ListItemText>
            <Typography sx={{ color: '#fff', fontSize: '0.875rem' }}>Play Selected</Typography>
          </ListItemText>
        </MenuItem>

        <MenuItem
          onClick={handleMultiPause}
          sx={{
            py: 1.25,
            '&:hover': { bgcolor: alpha('#10b981', 0.15) },
          }}
        >
          <ListItemIcon>
            <Pause fontSize="small" sx={{ color: '#f59e0b' }} />
          </ListItemIcon>
          <ListItemText>
            <Typography sx={{ color: '#fff', fontSize: '0.875rem' }}>Pause Selected</Typography>
          </ListItemText>
        </MenuItem>

        <Divider sx={{ my: 0.5, borderColor: alpha('#10b981', 0.15) }} />

        <MenuItem
          onClick={handleMultipleDelete}
          sx={{
            py: 1.25,
            '&:hover': { bgcolor: alpha('#ef4444', 0.15) },
          }}
        >
          <ListItemIcon>
            <Delete fontSize="small" sx={{ color: '#ef4444' }} />
          </ListItemIcon>
          <ListItemText>
            <Typography sx={{ color: '#ef4444', fontSize: '0.875rem' }}>Delete Selected</Typography>
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}

// Stats Card Component
// Trend/istatistik hesabı backend'e taşındı (GET /monitors/dashboard-stats).
// Kartların varsayılan (yüklenmeden önceki) boş durumu:
const EMPTY_DASHBOARD = {
  total: 0,
  active: 0,
  error: 0,
  successRate: null,
  trends: {
    total: { trend: null, trendUp: true },
    active: { trend: null, trendUp: true },
    error: { trend: null, trendUp: true },
    successRate: { trend: null, trendUp: true },
  },
}

function StatsCard({ title, value, color, trend, trendUp, index }) {
  // Ok yönü değişimin işaretini, renk ise iyi/kötü olduğunu gösterir
  const isFlat = trend ? /^[+-]?0%$/.test(trend) : false
  const goesDown = trend ? trend.trim().startsWith('-') : false
  const chipColor = isFlat ? '#94a3b8' : trendUp ? '#10b981' : '#ef4444'
  return (
    <Card
      component={motion.div}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1, duration: 0.4 }}
      sx={{
        bgcolor: alpha('#fff', 0.03),
        backdropFilter: 'blur(20px)',
        border: `1px solid ${alpha(color, 0.2)}`,
        borderRadius: 2.5,
        transition: 'all 0.2s',
        '&:hover': {
          borderColor: alpha(color, 0.4),
          transform: 'translateY(-4px)',
          boxShadow: `0 8px 24px ${alpha(color, 0.15)}`,
        },
      }}
    >
      <CardContent sx={{ p: 2.5 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Typography
            sx={{
              fontSize: '0.875rem',
              fontWeight: 600,
              color: alpha('#fff', 0.7),
            }}
          >
            {title}
          </Typography>
          {trend && (
            <Chip
              icon={goesDown ? <TrendingDown sx={{ fontSize: 14 }} /> : <TrendingUp sx={{ fontSize: 14 }} />}
              label={trend}
              size="small"
              sx={{
                height: 20,
                bgcolor: alpha(chipColor, 0.15),
                color: chipColor,
                fontSize: '0.7rem',
                fontWeight: 700,
                border: `1px solid ${alpha(chipColor, 0.3)}`,
                '& .MuiChip-icon': {
                  color: chipColor,
                },
              }}
            />
          )}
        </Box>

        <Typography
          sx={{
            fontSize: '2rem',
            fontWeight: 700,
            color,
            lineHeight: 1,
          }}
        >
          {value}
        </Typography>
      </CardContent>
    </Card>
  )
}

// Main Dashboard
export default function Dashboard() {
  const userRedux = useSelector(selectUser)
  
  const [monitors, setMonitors] = useState([])
  const [dashboard, setDashboard] = useState(EMPTY_DASHBOARD)
  const [filteredMonitors, setFilteredMonitors] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [allSelected, setAllSelected] = useState(false)
  const [selectMonitors, setSelectMonitors] = useState([])
  const [filtreOptions, setFiltereOptions] = useState([])
  const theme = useTheme()
  const navigate = useNavigate()
  const isSm = useMediaQuery(theme.breakpoints.down('md'))
  const isXs = useMediaQuery(theme.breakpoints.down('sm'))

  // Kart değerleri ve trendler backend'den (GET /monitors/dashboard-stats) gelir
  const stats = [
    {
      title: 'Total Monitor',
      value: dashboard.total,
      color: '#10b981',
      trend: dashboard.trends.total.trend,
      trendUp: dashboard.trends.total.trendUp,
    },
    {
      title: 'Active',
      value: dashboard.active,
      color: '#10b981',
      trend: dashboard.trends.active.trend,
      trendUp: dashboard.trends.active.trendUp,
    },
    {
      title: 'Error',
      value: dashboard.error,
      color: '#ef4444',
      trend: dashboard.trends.error.trend,
      trendUp: dashboard.trends.error.trendUp,
    },
    {
      title: 'Success Rate',
      value: dashboard.successRate != null ? `${dashboard.successRate}%` : '—',
      color: '#10b981',
      trend: dashboard.trends.successRate.trend,
      trendUp: dashboard.trends.successRate.trendUp,
    },
  ]
  const copyToClipboard = (text) => {
      navigator.clipboard.writeText(text)
      Swal.fire({
        icon: 'success',
        title: 'Kopyalandı!',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 1500,
        background: alpha(theme.palette.background.paper, 0.95),
        color: '#fff',
      })
    }

  // Fetch monitors + dashboard istatistikleri
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [monitorsRes, statsRes] = await Promise.all([
          api.get('monitors/'),
          api.get('monitors/dashboard-stats'),
        ])
        if (monitorsRes.data) setMonitors(monitorsRes.data)
        if (statsRes.data) setDashboard(statsRes.data)
      } catch (error) {
        console.error('Error fetching dashboard data:', error)
      }
    }

    fetchData()
    const interval = setInterval(fetchData, 30000)
    return () => clearInterval(interval)
  }, [])

  // Filter monitors
  useEffect(() => {
    if (!monitors || monitors.length === 0) {
      setFilteredMonitors([])
      return
    }

    let filtered = monitors

    // Search filter
    if (searchQuery.trim()) {
      const searchLower = searchQuery.toLowerCase()
      filtered = filtered.filter((monitor) => {
        const name = monitor.name?.toLowerCase().includes(searchLower)
        const type = monitor.monitorType?.toLowerCase().includes(searchLower)
        
        let host = false
        const monitorTypes = {
          HttpMonitor: 'httpMonitor',
          PingMonitor: 'pingMonitor',
          PortMonitor: 'portMonitor',
          KeywordMonitor: 'keyWordMonitor',
          CronJobMonitor: 'cronJobMonitor',
        }
        const typeKey = monitorTypes[monitor.monitorType]
        if (typeKey && monitor[typeKey]?.host) {
          host = monitor[typeKey].host.toLowerCase().includes(searchLower)
        }

        return name || type || host
      })
    }

    // Status filter
    if (filtreOptions.length > 0) {
      filtered = filtered.filter((monitor) => {
        if (filtreOptions.includes('paused')) {
          return filtreOptions.includes(monitor.status) || !monitor.isActiveByOwner
        }
        return filtreOptions.includes(monitor.status)
      })
    }

    setFilteredMonitors(filtered)
  }, [searchQuery, monitors, filtreOptions])

  const handleSelectMonitor = (id) => {
    setSelectMonitors((prev) => {
      const newSelection = prev.includes(id) ? prev.filter((m) => m !== id) : [...prev, id]
      setAllSelected(newSelection.length === filteredMonitors.length)
      return newSelection
    })
  }

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectMonitors([])
      setAllSelected(false)
    } else {
      setSelectMonitors(filteredMonitors.map((m) => m.id))
      setAllSelected(true)
    }
  }

  // DataGrid columns
 const columns = [
  {
    field: 'select',
    headerName: '',
    width: 50,
    disableColumnMenu: true,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    renderHeader: () => (
      <Checkbox
        size="small"
        checked={allSelected}
        indeterminate={selectMonitors.length > 0 && selectMonitors.length < filteredMonitors.length}
        onChange={handleSelectAll}
        sx={{
          color: alpha('#10b981', 0.5),
          '&.Mui-checked': { color: '#10b981' },
          '&.MuiCheckbox-indeterminate': { color: '#10b981' },
        }}
      />
    ),
    renderCell: (params) => (
      <Checkbox
        size="small"
        checked={selectMonitors.includes(params.id)}
        onChange={() => handleSelectMonitor(params.id)}
        sx={{
          color: alpha('#10b981', 0.5),
          '&.Mui-checked': { color: '#10b981' },
        }}
      />
    ),
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 100,
    disableColumnMenu: true,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => (
      <Box sx={{ display: 'flex', alignItems: 'center', alignContent: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
        <MonitorStatus 
          status={params.value} 
          iconSize={12} 
          sx={{ width: 24, height: 24, animeWidth: 15, animeHeight: 15 }} 
        />
      </Box>
    ),
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 1.5,
    minWidth: 150,
    align: 'left',
    headerAlign: 'left',
    renderCell: (params) => (
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Typography 
          sx={{ 
            color: '#fff', 
            fontSize: '0.875rem', 
            fontWeight: 600,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {params.value}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'host',
    headerName: 'Host & Type',
    flex: 2.5,
    minWidth: 200,
    align: 'left',
    headerAlign: 'left',
    renderCell: (params) => {
      const monitorTypes = {
        HttpMonitor: params.row.httpMonitor,
        PingMonitor: params.row.pingMonitor,
        PortMonitor: params.row.portMonitor,
        KeywordMonitor: params.row.keyWordMonitor,
        CronJobMonitor: params.row.cronJobMonitor,
      }
      const data = monitorTypes[params.row.monitorType]
      
      return (
        <Box 
          sx={{ 
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100%',
            py: 0.5,
          }}
        >
          <Typography 
            sx={{ 
              color: '#fff', 
              fontSize: '0.875rem',
              fontWeight: 500,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              mb: 0.25,
            }}
          >
            {data?.host || params.row.name}
          </Typography>
          
          <Chip
            label={params.row.monitorType}
            size="small"
            sx={{
              height: 18,
              fontSize: '0.7rem',
              fontWeight: 600,
              bgcolor: alpha('#10b981', 0.1),
              color: alpha('#10b981', 0.8),
              border: `1px solid ${alpha('#10b981', 0.2)}`,
              width: 'fit-content',
              '& .MuiChip-label': {
                px: 1,
              },
            }}
          />
        </Box>
      )
    },
  },
  {
    field: 'detail',
    headerName: '',
    width: 60,
    disableColumnMenu: true,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) =>{
      const monitorTypes = {
        HttpMonitor: params.row.httpMonitor,
        PingMonitor: params.row.pingMonitor,
        PortMonitor: params.row.portMonitor,
        KeywordMonitor: params.row.keyWordMonitor,
        CronJobMonitor: params.row.cronJobMonitor,
      }
      const data = monitorTypes[params.row.monitorType]
      return (
      <Tooltip title="Copy" arrow placement="top">
        <IconButton
          size="small"
          onClick={() => copyToClipboard(data.host)}
          sx={{
            color: alpha('#10b981', 0.7),
            transition: 'all 0.2s',
            '&:hover': {
              color: '#10b981',
              bgcolor: alpha('#10b981', 0.15),
              transform: 'scale(1.1)',
            },
          }}
        >
          <ContentCopy fontSize="small" />
        </IconButton>
      </Tooltip>
    )
    } 
  },
  {
    field: 'logs',
    headerName: 'Logs',
    flex: isSm ? 1 : 2.5,
    minWidth: 200,
    disableColumnMenu: true,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => {
      const logs = (params.row.logs || []).slice(-24)
      const successRate = logs.length > 0 
        ? Math.round((logs.filter(l => l.status === 'up').length / logs.length) * 100)
        : 0
      
      return (
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            gap: 0.5,
          }}
        >
          {/* Success Rate */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography
              sx={{
                fontSize: '0.75rem',
                fontWeight: 700,
                color: successRate >= 90 ? '#10b981' : successRate >= 70 ? '#f59e0b' : '#ef4444',
              }}
            >
              {successRate}%
            </Typography>
          </Box>

          {/* Activity Bars */}
          <Box sx={{ display: 'flex', gap: 0.4, justifyContent: 'center' }}>
            {logs.map((log, idx) => (
              <Tooltip
                key={idx}
                title={
                  <Box sx={{ p: 0.5 }}>
                    <Typography fontSize={11} fontWeight={600}>
                      {log.status === 'up' ? 'Başarılı' : log.status === 'down' ? 'Hatalı' : 'Belirsiz'}
                    </Typography>
                    <Typography fontSize={10}>
                      {log.responseTime}ms
                    </Typography>
                    <Typography fontSize={10}>
                      {new Date(log.createdAt).toLocaleTimeString('tr-TR')}
                    </Typography>
                  </Box>
                }
                arrow
                placement="top"
              >
                <Box
                  sx={{
                    width: 8,
                    height: 20,
                    borderRadius: 0.5,
                    bgcolor: 
                      log.status === 'up' ? '#10b981' : 
                      log.status === 'down' ? '#ef4444' : 
                      '#f59e0b',
                    opacity: 0.85,
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    '&:hover': {
                      opacity: 1,
                      transform: 'scaleY(1.3)',
                      boxShadow: `0 0 6px ${
                        log.status === 'up' ? '#10b981' : 
                        log.status === 'down' ? '#ef4444' : 
                        '#f59e0b'
                      }`,
                    },
                  }}
                />
              </Tooltip>
            ))}
          </Box>
        </Box>
      )
    },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 80,
    disableColumnMenu: true,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <MenuButton 
          monitor={params.row} 
          monitors={monitors} 
          setMonitors={setMonitors} 
        />
      </Box>
    ),
  },
]

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: '#fff',
            mb: 0.5,
          }}
        >
          Monitoring Dashboard
        </Typography>
        <Typography sx={{ fontSize: '0.9rem', color: alpha('#fff', 0.6) }}>
          Sistemlerinizi gerçek zamanlı izleyin
        </Typography>
      </Box>

      {/* Stats Cards */}
      <Grid container spacing={2.5} sx={{ mb: 4 }}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <StatsCard {...stat} index={index} />
          </Grid>
        ))}
      </Grid>

      {/* Main Content */}
      <Paper
        sx={{
          bgcolor: alpha('#fff', 0.03),
          backdropFilter: 'blur(20px)',
          border: `1px solid ${alpha('#10b981', 0.15)}`,
          borderRadius: 2.5,
          p: 3,
        }}
      >
        {/* Toolbar */}
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 600 }}>
              Monitoring List
            </Typography>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => navigate('new/monitor')}
              sx={{
                bgcolor: '#10b981',
                color: '#000',
                fontWeight: 600,
                px: 3,
                borderRadius: 2,
                textTransform: 'none',
                '&:hover': {
                  bgcolor: '#059669',
                },
              }}
            >
              New Monitor
            </Button>
          </Box>

          <Divider sx={{ mb: 3, borderColor: alpha('#10b981', 0.15) }} />

          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <TextField
              placeholder="Search name or host..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ color: alpha('#10b981', 0.6) }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                flex: 1,
                minWidth: 300,
                '& .MuiOutlinedInput-root': {
                  bgcolor: alpha('#fff', 0.03),
                  borderRadius: 2,
                  color: '#fff',
                  height: 40,
                  '& fieldset': {
                    borderColor: alpha('#10b981', 0.2),
                  },
                  '&:hover fieldset': {
                    borderColor: alpha('#10b981', 0.3),
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#10b981',
                  },
                },
              }}
            />

            <BulkActionsMenu
              selectMonitors={selectMonitors}
              setSelectMonitors={setSelectMonitors}
              setMonitors={setMonitors}
            />

            <FilterMenu filtreOptions={filtreOptions} setFiltereOptions={setFiltereOptions} />
          </Box>
        </Box>

        {/* DataGrid */}
        <Box
          sx={{
            height: 600,
            '& .MuiDataGrid-root': {
              border: 'none',
              color: '#fff',
            },
            '& .MuiDataGrid-cell': {
              borderBottom: `1px solid ${alpha('#10b981', 0.1)}`,
            },
            '& .MuiDataGrid-columnHeaders': {
              bgcolor: alpha('#10b981', 0.05),
              borderBottom: `1px solid ${alpha('#10b981', 0.2)}`,
            },
            '& .MuiDataGrid-columnHeader': {
              color: '#10b981',
              fontWeight: 700,
            },
            '& .MuiDataGrid-row': {
              '&:hover': {
                bgcolor: alpha('#10b981', 0.05),
              },
            },
            '& .MuiDataGrid-footerContainer': {
              borderTop: `1px solid ${alpha('#10b981', 0.1)}`,
            },
            '& .MuiTablePagination-root': {
              color: '#fff',
            },
            '& .MuiTablePagination-selectIcon': {
              color: '#10b981',
            },
            '& .MuiTablePagination-actions button': {
              color: '#10b981',
            },
          }}
        >
          <DataGrid
            rows={filteredMonitors}
            columns={columns}
            pageSizeOptions={[10, 25, 50]}
            initialState={{
              pagination: { paginationModel: { pageSize: 10 } },
            }}
            disableRowSelectionOnClick
            disableColumnFilter
            sx={{
              '& .MuiDataGrid-virtualScroller': {
                '&::-webkit-scrollbar': {
                  width: 6,
                  height: 6,
                },
                '&::-webkit-scrollbar-track': {
                  bgcolor: alpha('#fff', 0.05),
                  borderRadius: 1,
                },
                '&::-webkit-scrollbar-thumb': {
                  bgcolor: alpha('#10b981', 0.3),
                  borderRadius: 1,
                  '&:hover': {
                    bgcolor: alpha('#10b981', 0.5),
                  },
                },
              },
            }}
          />
        </Box>
      </Paper>
    </Box>
  )
}